import { intervalToDuration } from 'date-fns/intervalToDuration';

/**
 * Formats a "time left" number into a human-readable string, e.g. "2 hours and 3 minutes", "3
 * minutes and 30 seconds", or "45 seconds". Only shows the top two largest units.
 */
export function formatHumanReadableTimeLeft(timeLeftInMs: number) {
  const duration = intervalToDuration({ start: 0, end: timeLeftInMs });

  const parts = [];
  if (duration.hours) {
    parts.push(`${duration.hours} hour${duration.hours > 1 ? 's' : ''}`);
  }
  if (duration.minutes) {
    parts.push(`${duration.minutes} minute${duration.minutes > 1 ? 's' : ''}`);
  }
  if (parts.length < 2 && duration.seconds) {
    parts.push(`${duration.seconds} second${duration.seconds > 1 ? 's' : ''}`);
  }

  return parts.join(' and ');
}
